import axios from 'axios';

import type { LocationFeed } from '../models/listing';
import { locationFeedSchema } from '../models/listing';

export async function getLocationById(locationId: string): Promise<LocationFeed> {
	const data = (await axios.get<unknown>(`/api/locations/all/${locationId}/`)).data;
	return locationFeedSchema.parse(data);
}
